export { ExitPopupAccommodationPage } from "./ExitPopupAccommodationPage";
export { ExitPopupSearchPage } from "./ExitPopupSearchPage";